// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/tiles/fundo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/tiles/caminho.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/tiles/inicio.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/tiles/final.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === CONTAINER PRINCIPAL (baseado no editor-iso.html) === */
.isometric-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  -webkit-user-select: none;
          user-select: none;
  display: grid;
  place-items: center;
  justify-content: center;
  align-content: center;
}

/* Palco: tamanho "mundo" real e uma única transformação para tudo */
.iso-stage {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 3072px;          /* LARGURA DO CENÁRIO: 48 tiles × 64px = 3072px */
  height: 1536px;         /* ALTURA DO CENÁRIO: 48 tiles × 32px = 1536px */
  transform-origin: center center;
  will-change: transform;
  overflow: hidden;
}

@media screen and (max-width: 768px) {
  .iso-stage {
    left: 66% !important;
  }
}

/* As duas camadas ocupam exatamente o palco (mesma caixa), empilhadas */
.isometric-background,
.isometric-board {
  position: absolute;
  inset: 0;               /* left:0; top:0; right:0; bottom:0; */
}


/* === LAYER DE BACKGROUND === */
.isometric-background {
  position: absolute;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center center;
  image-rendering: pixelated;
  z-index: 0;
}

/* === BOARD DE TILES === */
.isometric-board {
  position: absolute;
  z-index: 1;
  -webkit-user-select: none;
          user-select: none;
}


/* Mata qualquer transform/left/top inline nas camadas,
   garantindo que só o palco (.iso-stage) faça a transformação */
.isometric-background,
.isometric-board {
  transform: none !important;
  left: 0 !important;
  top: 0 !important;
}

/* opcional: melhora nítidez em escalas fracionadas, se forem sprites/bmp */
.isometric-board, .tile, .isometric-background {
  image-rendering: pixelated;
}

/* se existir UI sobreposta (ex.: .news-board), garanta z-index alto */
.news-board { z-index: 1000; }

/* se quiser que cliques passem "através" do background até os tiles: */
.isometric-background { pointer-events: none; }

.news-board-content-image {
  position: relative;
  width: 60dvw; /* 60% da largura total da tela */
  height: 50dvh; /* 30% da altura total da tela */
  margin: 0 50px;
  background-size: cover;
  background-repeat: no-repeat;
  image-rendering: -webkit-optimize-contrast;
  z-index: 1001;
  border-radius: 30px;
  border: 5px solid rgba(255, 255, 255, 0.1);
}

.button-container {
  position: relative;
  display: flex;
  justify-content: center;
  margin-top: 0px;
  z-index: 1003;
  pointer-events: auto;
}
.button-container > button {
  width: 150px;
  height: 45px;
}
@media screen and (max-width: 768px) {
  .button-container > button {
    scale: 1;
    width: 115px;
    height: 35px;
  }  
}
@media screen and (max-width: 480px) {
  .button-container > button {
    scale: 1;
    width: 100px;
    height: 30px;
  }  
}

/* === TILES === */

.tile {
  cursor: pointer;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  image-rendering: pixelated;
  box-sizing: border-box;
}

.tile:hover {
  filter: brightness(1.3); 
  /* Não elevamos o tile em Z */
  /* transform: translateZ(5px); */
  /* animation: pulse 2s infinite; */
  /*z-index: 100; */
}

.fundo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  border: 0px solid rgba(0, 0, 0, 0.2);
}

.caminho {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  border: 0px solid rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  opacity: 1.0;
}

.inicio {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  border: 0px solid #4CAF50;
  opacity: 0.0;
  /* animation: pulse 2s infinite; */
  /*  z-index: 5; */
}

.fim {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  border: 0px solid #F44336;
  opacity: 0.0;
  /* animation: pulse 2s infinite; */
  /*  z-index: 5; */
}

.loading {
  color: white;
  font-size: 20px;
  font-weight: bold;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.7);
  padding: 20px;
  border-radius: 10px;
  z-index: 1000;
}

@keyframes pulse {
  0% { filter: brightness(1); }
  50% { filter: brightness(1.2); }
  100% { filter: brightness(1); }
} `, "",{"version":3,"sources":["webpack://./src/components/IsometricBoard.css"],"names":[],"mappings":"AAAA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA,oEAAoE;AACpE;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa,WAAW,iDAAiD;EACzE,cAAc,UAAU,gDAAgD;EACxE,+BAA+B;EAC/B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA,wEAAwE;AACxE;;EAEE,kBAAkB;EAClB,QAAQ,gBAAgB,sCAAsC;AAChE;;;AAGA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,0BAA0B;EAC1B,kCAAkC;EAClC,0BAA0B;EAC1B,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,UAAU;EACV,yBAAiB;UAAjB,iBAAiB;AACnB;;;AAGA;gEACgE;AAChE;;EAEE,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,2EAA2E;AAC3E;EACE,0BAA0B;AAC5B;;AAEA,sEAAsE;AACtE,cAAc,aAAa,EAAE;;AAE7B,uEAAuE;AACvE,wBAAwB,oBAAoB,EAAE;;AAE9C;EACE,kBAAkB;EAClB,YAAY,EAAE,iCAAiC;EAC/C,aAAa,EAAE,gCAAgC;EAC/C,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE;IACE,QAAQ;IACR,YAAY;IACZ,YAAY;EACd;AACF;AACA;EACE;IACE,QAAQ;IACR,YAAY;IACZ,YAAY;EACd;AACF;;AAEA,kBAAkB;;AAElB;EACE,eAAe;EACf,4BAA4B;EAC5B,0BAA0B;EAC1B,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,yDAAkD;EAClD,oCAAoC;AACtC;;AAEA;EACE,yDAAoD;EACpD,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yDAAmD;EACnD,yBAAyB;EACzB,YAAY;EACZ,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,yDAAkD;EAClD,yBAAyB;EACzB,YAAY;EACZ,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,KAAK,qBAAqB,EAAE;EAC5B,MAAM,uBAAuB,EAAE;EAC/B,OAAO,qBAAqB,EAAE;AAChC","sourcesContent":["/* === CONTAINER PRINCIPAL (baseado no editor-iso.html) === */\r\n.isometric-container {\r\n  position: relative;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  overflow: hidden;\r\n  user-select: none;\r\n  display: grid;\r\n  place-items: center;\r\n  justify-content: center;\r\n  align-content: center;\r\n}\r\n\r\n/* Palco: tamanho \"mundo\" real e uma única transformação para tudo */\r\n.iso-stage {\r\n  position: absolute;\r\n  left: 50%;\r\n  top: 50%;\r\n  width: 3072px;          /* LARGURA DO CENÁRIO: 48 tiles × 64px = 3072px */\r\n  height: 1536px;         /* ALTURA DO CENÁRIO: 48 tiles × 32px = 1536px */\r\n  transform-origin: center center;\r\n  will-change: transform;\r\n  overflow: hidden;\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .iso-stage {\r\n    left: 66% !important;\r\n  }\r\n}\r\n\r\n/* As duas camadas ocupam exatamente o palco (mesma caixa), empilhadas */\r\n.isometric-background,\r\n.isometric-board {\r\n  position: absolute;\r\n  inset: 0;               /* left:0; top:0; right:0; bottom:0; */\r\n}\r\n\r\n\r\n/* === LAYER DE BACKGROUND === */\r\n.isometric-background {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-repeat: no-repeat;\r\n  background-size: 100% 100%;\r\n  background-position: center center;\r\n  image-rendering: pixelated;\r\n  z-index: 0;\r\n}\r\n\r\n/* === BOARD DE TILES === */\r\n.isometric-board {\r\n  position: absolute;\r\n  z-index: 1;\r\n  user-select: none;\r\n}\r\n\r\n\r\n/* Mata qualquer transform/left/top inline nas camadas,\r\n   garantindo que só o palco (.iso-stage) faça a transformação */\r\n.isometric-background,\r\n.isometric-board {\r\n  transform: none !important;\r\n  left: 0 !important;\r\n  top: 0 !important;\r\n}\r\n\r\n/* opcional: melhora nítidez em escalas fracionadas, se forem sprites/bmp */\r\n.isometric-board, .tile, .isometric-background {\r\n  image-rendering: pixelated;\r\n}\r\n\r\n/* se existir UI sobreposta (ex.: .news-board), garanta z-index alto */\r\n.news-board { z-index: 1000; }\r\n\r\n/* se quiser que cliques passem \"através\" do background até os tiles: */\r\n.isometric-background { pointer-events: none; }\r\n\r\n.news-board-content-image {\r\n  position: relative;\r\n  width: 60dvw; /* 60% da largura total da tela */\r\n  height: 50dvh; /* 30% da altura total da tela */\r\n  margin: 0 50px;\r\n  background-size: cover;\r\n  background-repeat: no-repeat;\r\n  image-rendering: -webkit-optimize-contrast;\r\n  z-index: 1001;\r\n  border-radius: 30px;\r\n  border: 5px solid rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.button-container {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-top: 0px;\r\n  z-index: 1003;\r\n  pointer-events: auto;\r\n}\r\n.button-container > button {\r\n  width: 150px;\r\n  height: 45px;\r\n}\r\n@media screen and (max-width: 768px) {\r\n  .button-container > button {\r\n    scale: 1;\r\n    width: 115px;\r\n    height: 35px;\r\n  }  \r\n}\r\n@media screen and (max-width: 480px) {\r\n  .button-container > button {\r\n    scale: 1;\r\n    width: 100px;\r\n    height: 30px;\r\n  }  \r\n}\r\n\r\n/* === TILES === */\r\n\r\n.tile {\r\n  cursor: pointer;\r\n  background-repeat: no-repeat;\r\n  background-size: 100% 100%;\r\n  image-rendering: pixelated;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.tile:hover {\r\n  filter: brightness(1.3); \r\n  /* Não elevamos o tile em Z */\r\n  /* transform: translateZ(5px); */\r\n  /* animation: pulse 2s infinite; */\r\n  /*z-index: 100; */\r\n}\r\n\r\n.fundo {\r\n  background-image: url('../assets/tiles/fundo.png');\r\n  border: 0px solid rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.caminho {\r\n  background-image: url('../assets/tiles/caminho.png');\r\n  border: 0px solid rgba(0, 0, 0, 0.1);\r\n  border-radius: 2px;\r\n  opacity: 1.0;\r\n}\r\n\r\n.inicio {\r\n  background-image: url('../assets/tiles/inicio.png');\r\n  border: 0px solid #4CAF50;\r\n  opacity: 0.0;\r\n  /* animation: pulse 2s infinite; */\r\n  /*  z-index: 5; */\r\n}\r\n\r\n.fim {\r\n  background-image: url('../assets/tiles/final.png');\r\n  border: 0px solid #F44336;\r\n  opacity: 0.0;\r\n  /* animation: pulse 2s infinite; */\r\n  /*  z-index: 5; */\r\n}\r\n\r\n.loading {\r\n  color: white;\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  background: rgba(0, 0, 0, 0.7);\r\n  padding: 20px;\r\n  border-radius: 10px;\r\n  z-index: 1000;\r\n}\r\n\r\n@keyframes pulse {\r\n  0% { filter: brightness(1); }\r\n  50% { filter: brightness(1.2); }\r\n  100% { filter: brightness(1); }\r\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
